import { measurementUnitVocabulary } from '@cd3p/core/types/common';

import { useSelector } from 'third-party';

import { appSelectors } from 'selectors';

export const useMeasurementUnit = () => {
  const measurementUnit = useSelector(appSelectors.measurementUnit);

  return measurementUnitVocabulary[measurementUnit];
};
